import React, { useEffect, useRef, useState } from "react";
import api from "../../api/axios";

const ModelSelect = ({ value = "", onChange, models = [], className = "", disabled = false, placeholder = "Saisir le modèle", fullWidth = false }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedLabel, setSelectedLabel] = useState("");
  const root = useRef(null);

  useEffect(() => {
    const selected = models.find((model) => String(model.id) === String(value));
    if (selected) setSelectedLabel(selected.modele);
    else if (!value) setSelectedLabel("");
  }, [models, value]);

  useEffect(() => {
    const close = (event) => !root.current?.contains(event.target) && setOpen(false);
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);

  useEffect(() => {
    if (!open) return undefined;
    const controller = new AbortController();
    const timer = setTimeout(async () => {
      try {
        const response = await api.get("/models", { params: { dropdown: 1, search: query, limit: 30 }, signal: controller.signal });
        setOptions(response.data);
        const selected = response.data.find((model) => String(model.id) === String(value));
        if (selected) setSelectedLabel(selected.modele);
      } catch (error) {
        if (error.code !== "ERR_CANCELED") setOptions([]);
      }
    }, 180);
    return () => { clearTimeout(timer); controller.abort(); };
  }, [open, query, value]);

  const select = (model) => {
    setSelectedLabel(model?.modele || "");
    setQuery("");
    setOpen(false);
    onChange?.({ target: { value: model ? String(model.id) : "" } });
  };

  return <div ref={root} className={`relative ${className}`} style={{ width: fullWidth ? "100%" : "236px", maxWidth: "100%" }}>
    <input
      value={open ? query : selectedLabel}
      onFocus={() => { setQuery(""); setOpen(true); }}
      onChange={(event) => { setQuery(event.target.value); setOpen(true); }}
      disabled={disabled}
      placeholder={placeholder}
      className="h-[42px] w-full rounded border border-[#b3b3b3] bg-white px-3 text-sm outline-none focus:border-2 focus:border-[#2684ff] disabled:bg-gray-100"
    />
    {open && <div className="absolute z-[100] mt-1 w-full min-w-[240px] rounded border bg-white p-2 shadow-xl">
      <button type="button" onClick={() => select(null)} className="block w-full rounded px-3 py-2 text-left text-gray-500 hover:bg-gray-100">Aucun modèle</button>
      <div className="max-h-64 overflow-y-auto">
        {options.map((model) => <button key={model.id} type="button" onClick={() => select(model)} className="block w-full rounded px-3 py-2 text-left hover:bg-blue-50">{model.modele}</button>)}
        {!options.length && <p className="px-3 py-2 text-sm text-gray-500">Aucun modèle trouvé</p>}
      </div>
    </div>}
  </div>;
};

export default ModelSelect;
